/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TLoginRequest } from '../models/TLoginRequest';
import type { TLoginResponse } from '../models/TLoginResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * Login
     * @param requestBody
     * @returns TLoginResponse TLoginResponse
     * @throws ApiError
     */
    public static login(
        requestBody: TLoginRequest,
    ): CancelablePromise<TLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
